
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/knear",
      function () {
        return require("private-next-pages/success-stories/knear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/knear"])
      });
    }
  